module.exports = __webpack_public_path__ + "img/sdg_icon_03.8b8fd525.png";